enum ErrorMessageId {
  InvalidEmail = 'invalid-email',
  RequiredField = 'required-field',
  InvalidField = 'invalid-field',
}

export default ErrorMessageId;
